import csRaw from '@/assets/consents/marketing/1.0/cs.md?raw';
import enRaw from '@/assets/consents/marketing/1.0/en.md?raw';

/** GDPR marketing-consent text for the given locale (cs authoritative, en otherwise). */
export function getGdprConsentText(locale: string): string {
  return locale.toLowerCase().startsWith('cs') ? csRaw : enRaw;
}
